import { Backdrop, withStyles } from '@material-ui/core';
import hexToRGBA from '~utils/hex-to-rgba';

export default withStyles((theme) => ({
  root: {
    backgroundColor: `${hexToRGBA(theme.colors.dark, 0.8)}`,
  },
  invisible: {},
}))(Backdrop);
